import { t } from "i18next";

import { Box, Typography } from "@mui/material";

import { theme } from "@/src/theme/theme";

import { addThousandsSeparator } from "@/src/utils/numberUtils";

interface TargetPriceOverlayProps {
  targetPrice: number;
  isMobile: boolean;
}

export const TargetPriceOverlay = ({
  targetPrice,
  isMobile
}: TargetPriceOverlayProps) => {
  return (
    <Box
      sx={{
        position: "absolute",
        top: 0,
        left: 0,
        backgroundColor: theme.palette.misc.backdropOverlay,
        color: theme.palette.common.white,
        padding: isMobile ? "4px 8px" : "6px 12px",
        borderRadius: "4px",
        zIndex: 25,
        pointerEvents: "none",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}
    >
      <Typography
        variant="body2"
        sx={{
          fontSize: isMobile
            ? theme.typography.body2.fontSize
            : theme.typography.body1.fontSize,
          fontWeight: theme.typography.fontWeightMedium,
          whiteSpace: "nowrap"
        }}
      >
        {t("components.auctionItem.vehicleImageTargetPrice")}:{" "}
        {addThousandsSeparator(targetPrice)} €
      </Typography>
    </Box>
  );
};
